import { topicsItems } from '@/mocks/anime';

export default function Topics() {
  const tagStyles: Record<string, string> = {
    hot: 'bg-primary-100 text-primary-700',
    trending: 'bg-accent-100 text-accent-700',
    new: 'bg-secondary-100 text-secondary-700',
  };

  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            当前最受关注的动漫话题，加入讨论发现更多精彩
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
          {topicsItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-100 hover:bg-background-200/70 border border-background-200/60 hover:border-primary-200/50 rounded-xl px-5 py-3.5 cursor-pointer transition-all duration-200 min-w-[140px] text-center"
            >
              <div className="flex items-center justify-center gap-2 mb-1">
                <span className="font-heading text-base font-bold text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                  {item.name}
                </span>
                {item.tag && (
                  <span className={`px-1.5 py-0.5 text-xs font-medium rounded-md whitespace-nowrap ${tagStyles[item.tag] || 'bg-background-200 text-foreground-600'}`}>
                    {item.tag === 'hot' ? '热门' : item.tag === 'trending' ? '上升' : item.tag === 'new' ? '新晋' : ''}
                  </span>
                )}
              </div>
              <div className="text-xs text-foreground-500">{item.count} 讨论</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}